import React from 'react'
import styled from 'styled-components'

import { FaBars } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { links } from '../utils/constants'
import CartButtons from './CartButtons'
import { useProductsContext } from '../context/products_context'
import { useUserContext } from '../context/user_context'

const Nav = () => {
  let {myUser} = useUserContext();
  let {openSideBar} = useProductsContext();
  
  return <NavContainer> 
              <div className='nav-center'>
                  <div className='nav-header'>
                    <Link to='/'>  <h2 className='logo-text'>BenStore </h2></Link>  
                        <button type="button" className='nav-toggle' onClick={openSideBar} >
                          <FaBars></FaBars>
                        </button>
                  </div>
                  <ul className='nav-links'>
                    {
                      links.map(({id, url, text})=>{
                        return <li key={id}>
                                      <Link to={url}>{text}</Link>
                              </li>
                      })
                    }
                    {
                      myUser && <li>
                        <Link to='checkout'>checkout</Link></li>
                    }

                   </ul>
                   <CartButtons></CartButtons>
              </div>
        </NavContainer>
}

const NavContainer = styled.nav`
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .nav-center {
    width: 90vw;
    margin: 0 auto;
    max-width: var(--max-width);
  }
  .nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 175px;
      margin-left: -15px;
    }
   
  }
  .nav-toggle {
    background: transparent;
    border: transparent;
    color: rgb(138, 12, 126);
    cursor: pointer;
    svg {
      font-size: 2rem;
    }
  }
  .nav-links {
    display: none;
  }
  .cart-btn-wrapper {
    display: none;
  }
  @media (min-width: 992px) {
    .nav-toggle {
      display: none;
    }
    .nav-center {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
    }
    .nav-links {
      display: flex;
      justify-content: center;
      li {
        margin: 0 0.5rem;
      }
      a {
        color: rgb(138, 12, 126);
        font-size: 1rem;
        text-transform: capitalize;
        letter-spacing: var(--spacing);
        padding: 0.5rem;
        
      
        &:hover {
          border-bottom: 2px solid rgb(237, 182, 72);
        }
      }
    }
    .cart-btn-wrapper {
      display: grid;
    }
  }
`

export default Nav
